import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const FormatMono = props => (
  <SvgIcon {...props} viewBox="0 0 32 32">
    <path d="M27 24h-2v-16.988c0-0.553-0.448-1-1-1 0 0-0.906-0.13-1.437 0.58-0.28 0.378-6.563 8.033-6.563 8.033s-6.38-7.785-6.58-8.063c-0.502-0.69-1.42-0.55-1.42-0.55-0.553 0-1 0.447-1 1v16.988h-2c-0.553 0-1 0.448-1 1s0.447 1 1 1h6c0.552 0 1-0.448 1-1s-0.448-1-1-1h-2v-14.678l6.002 7.164c0.25 0.33 0.68 0.514 0.998 0.514 0.338 0 0.74-0.204 0.996-0.533l6.004-7.117v14.65h-2c-0.553 0-1 0.448-1 1s0.447 1 1 1h6c0.552 0 1-0.448 1-1s-0.448-1-1-1z" />
  </SvgIcon>
);

export default FormatMono;
